import { render, staticRenderFns } from "./OiltankManageDetail.vue?vue&type=template&id=5d17749c&scoped=true"
import script from "./OiltankManageDetail.vue?vue&type=script&lang=js"
export * from "./OiltankManageDetail.vue?vue&type=script&lang=js"
import style0 from "./OiltankManageDetail.vue?vue&type=style&index=0&id=5d17749c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17749c",
  null
  
)

export default component.exports